__turbopack_context__.v({
  "actionBar": "OrganizerCard-module-scss-module__ciiSjq__actionBar",
  "buttonGroup": "OrganizerCard-module-scss-module__ciiSjq__buttonGroup",
  "content": "OrganizerCard-module-scss-module__ciiSjq__content",
  "title": "OrganizerCard-module-scss-module__ciiSjq__title",
  "unnamedContent": "OrganizerCard-module-scss-module__ciiSjq__unnamedContent",
});
